import Vue from "vue";
import Router from "vue-router";
import VeeValidate from "vee-validate";
import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import moment from 'moment'
// Views 
import Home from "./views/Home";
import Survey from "./views/Survey";
import Dashboard from "./views/Dashboard";
import Surveys from "./views/Surveys";
//Font awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// import VueDropdown from 'vue-dynamic-dropdown';
import {
  faHome,faUser,faUserPlus,faSignInAlt,faSignOutAlt,faList,faQuestion,faChevronLeft,faChevronUp,
  faChevronDown, faChevronRight,faBars,faEdit,faSave,faTrash,faCheck,faBan,faCog,faTimes,faTimesCircle,faPlus, faSearch, faMinus,
  faBuilding, faSearchPlus,faTag, faLevelUpAlt, faLanguage, faUpload, faPaperPlane, faEye, faRobot, faInfoCircle,
  faEyeSlash, faPaperclip, faArrowLeft, faEnvelope, faExclamationTriangle, faArrowCircleLeft, faArrowCircleRight, faFolder, faPlay, faLink, faCheckCircle, faEllipsisV, faFileDownload,
  faVideo, faVideoSlash, faStar, faClipboard, faFileAlt, faCopy, faFileImport, faClone, faPhone, faUsers, faUserMinus, faUndo, faSms, faTrophy, faCalendar, faGlobe,
  faGraduationCap, faDownload, faTable, faSyncAlt, faArrowUp
} from '@fortawesome/free-solid-svg-icons';

library.add(faHome, faUser, faUserPlus, faSignInAlt, faSignOutAlt ,faList
  , faQuestion, faChevronLeft, faChevronRight, faChevronUp, faChevronDown, faBars, faSave, faEdit 
  ,faTrash, faCheck, faBan, faCog, faTimes, faTimesCircle, faPlus, faSearch, faBuilding, faSearchPlus, faMinus,
  faTag, faLevelUpAlt, faLanguage, faUpload, faPaperPlane, faEye, faRobot, faInfoCircle, faEyeSlash, faPaperclip,
  faArrowLeft, faEnvelope, faExclamationTriangle, faArrowCircleLeft, faArrowCircleRight, faFolder, faPlay, faLink, faCheckCircle, faEllipsisV, faFileDownload,
  faVideo, faVideoSlash, faStar, faClipboard, faFileAlt, faCopy, faFileImport, faClone, faPhone, faUsers, faUserMinus, faUndo , faSms, faTrophy, faCalendar, faGlobe,
  faGraduationCap, faDownload, faTable, faSyncAlt, faArrowUp);

Vue.use(Router);
Vue.use(VeeValidate, {inject: true, fieldsBagName: 'veeFields', errorBagName: 'veeErrors'});
Vue.use(BootstrapVue)
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.filter('formatDate', function(date) {
  if (date) {
    return moment(String(date)).format('DD/MM/YYYY HH:mm')
  }
});

const router = new Router({
  	mode: "history",
  	routes: [
    	{ path: "/", alias: "/home", name: "home", component: Home, meta: { requiresAuth: false, requiresAdmin: false } },
    	{ path: "/survey", alias: "/survey", name: "survey", component: Survey, meta: { requiresAuth: false, requiresAdmin: false } },
      { path: "/surveys", alias: "/surveys", name: "surveys", component: Surveys, meta: { requiresAuth: true, requiresAdmin: true } },
    	{ path: "/dashboard", alias: "/dashboard", name: "dashboard", component: Dashboard, meta: { requiresAuth: true, requiresAdmin: true } },
    ],
});

router.beforeEach(async (to, from, next) => {
  	const publicPages = ["/", "/survey"]
  	const authRequired = !publicPages.includes(to.path)
  	const userLoggedIn = localStorage.getItem('user');
  	if (authRequired && !userLoggedIn) {
	    next('/');
  	} else {
  		next();
  	}
})

export default router;